import { CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';
import { catchError, map, of } from 'rxjs';
import { LeapmotorUserDTO } from '../models/user-dto';


@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  userModel: LeapmotorUserDTO;
  
  constructor(private router: Router,
    private userService: UserService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const userInfo$ = this.userService.getUserInfo();    
    if (this.userModel == undefined) {
      return userInfo$.pipe(map(userData => {
        this.userModel = userData;        
        return this.checkRoute(route, state);
      }),
        catchError((err) => {
          console.error(err);
          this.router.navigate(['/home']);
          return of(false);
        }));
    } else {
      return this.checkRoute(route, state);
    }
  }

  checkRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {    
    if (route.data["roles"]) {
      let rolValid = false;
      if (route.data["roles"].toString().split(",").some(r => this.userModel.RolesListString.indexOf(r) >= 0)) {
        rolValid = true;
      }
      if (rolValid === false) {
        console.log("Rol inválido");
        console.log(this.userModel, this.userModel.RolesListString, route.data["roles"]);
        this.router.navigate(['/home']);
        return false;
      }
    }
    return true;
  }

}
